import React from 'react';

const Text = ({
  children,
  size = 'base',
  color = 'gray-600',
  weight = 'normal',
  className = '',
  ...props
}) => {
  const sizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl'
  };

  const weights = {
    light: 'font-light',
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold'
  };

  return (
    <p className={`${sizes[size]} text-${color} ${weights[weight]} ${className}`} {...props}>
      {children}
    </p>
  );
};

export default Text;
